'use client'

export { PlatformBanner as ClientPlatformBanner } from '@/baseComponents'
